import Button from "components/Button";
import Grid from "components/Grid";
import Modal from "components/Modal";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { FC } from "react";
import { IconContext } from "react-icons";
import { BiLoaderAlt } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import theme from "theme";
import "./JobPost.css";
import {
    Agency,
    AgencyHeader,
    AgencyRow,
    ButtonSection,
    ContentSection,
    HeadingSection,
    JobPostWrapper,
} from "./JobPost.styled";
import { useJobPost } from "./useJobPost";

export const JobPost: FC = () => {
    const {
        agency,
        handleAgencyChange,
        data,
        isFetching,
        isModalOpen,
        toggleModal,
        categoryName,
        categoryNameError,
        isSubmittingForm,
        handleCategoryNameChange,
        handleSubmit,
        handleNext,
        isEdit,
    } = useJobPost();

    const activeAgencies = data
        ? data.filter((agency) => agency.status === "active")
        : [];
    const inActiveAgencies = data
        ? data.filter((agency) => agency.status !== "active")
        : [];

    return (
        <JobPostWrapper>
            <HeadingSection>
                <Text variant="heading1">
                    {isEdit ? "Edit Post" : "Post Casting"}
                </Text>
                <Text variant="button2">Hire the talent you need</Text>
            </HeadingSection>
            <ContentSection>
                <Text variant="button1" color={theme.colors.grey.dark}>
                    First, select a category
                </Text>

                <AgencyRow>
                    {isFetching && (
                        <IconContext.Provider value={{ className: "loader" }}>
                            <div>
                                <BiLoaderAlt />
                            </div>
                        </IconContext.Provider>
                    )}

                    {!isFetching && data && data.length > 0 && (
                        <>
                            {activeAgencies.map((category) => (
                                <Agency
                                    key={category.id}
                                    onClick={() =>
                                        handleAgencyChange(category.id)
                                    }
                                    isSelected={agency === category.id}
                                >
                                    <img
                                        src={category?.image_url}
                                        alt={category.name}
                                    />
                                    {agency === category.id && (
                                        <FaCheckCircle />
                                    )}

                                    <AgencyHeader>
                                        <Text variant="button2">
                                            {category.name}
                                        </Text>
                                    </AgencyHeader>
                                </Agency>
                            ))}
                            {inActiveAgencies.map((category) => (
                                <Agency
                                    key={category.id}
                                    // onClick={() =>
                                    //     handleAgencyChange(category.id)
                                    // }
                                    isSelected={agency === category.id}
                                    style={{ cursor: "not-allowed" }}
                                >
                                    <img
                                        src={category?.image_url}
                                        alt={category.name}
                                    />
                                    <AgencyHeader>
                                        <Text variant="button2">
                                            {category.name}
                                        </Text>
                                    </AgencyHeader>
                                </Agency>
                            ))}
                        </>
                    )}
                </AgencyRow>
                <ButtonSection>
                    <Button
                        type="button"
                        variant="filled"
                        disabled={agency === -1}
                        onClick={handleNext}
                    >
                        Next
                    </Button>
                </ButtonSection>
            </ContentSection>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>Add Category</Modal.Header>
                <Modal.Content>
                    <TextInput
                        label="Category Name"
                        placeholder="Ex. Photoshoots"
                        value={categoryName}
                        onChange={handleCategoryNameChange}
                        errorMsg={categoryNameError}
                    />
                </Modal.Content>
                <Modal.Footer>
                    <Grid
                        row={true}
                        justify="flex-end"
                        expanded
                        columnGap={1}
                        marginTop={2}
                    >
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={() => toggleModal(true)}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="filled"
                            onClick={handleSubmit}
                            isLoading={isSubmittingForm}
                        >
                            Add
                        </Button>
                    </Grid>
                </Modal.Footer>
            </Modal>
        </JobPostWrapper>
    );
};
